import React from "react";
import ReactDOM from "react-dom/client";
import "bootstrap/dist/css/bootstrap.css";
import ReactGA from "react-ga4";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

const measurementId = 'G-5Q59WLBXLP';
if (measurementId) {
  ReactGA.initialize(measurementId);
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
